<template>
    <b-card no-body>
        <b-modal id="rename" title="Cihaz İsimlendir" no-close-on-esc no-close-on-backdrop>
            <mobile-app-rename v-model="app"></mobile-app-rename>
            <template #modal-footer><v-executer :loading="loading" :action="setAlias">Güncelle</v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    pagination="server"
                    :fields="fields"
                    :buttons="buttons">
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-auto">
                                    <b-dropdown id="app-drop" variant="outline-primary" text="Uygulamalar">
                                        <b-dropdown-item v-on:click="downloadTMSHR">IK - TABLET</b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>
                        </template>
                </v-table>
    </b-card>
</template>

<script>
import { BCard, BDropdown, BDropdownItem } from 'bootstrap-vue';
import MobileDeviceOperationsApi from '@/api/mobile-device-operations';
import MobileAppRename from './components/MobileAppRename.vue';
import Additional from '@/utilities/additional';

export default {
    components:{
        BCard,
        MobileAppRename,
        BDropdown, 
        BDropdownItem
    },
    data(){
        return {
            fields:[
                {name:'Cihaz ID',key:'IdentifyCode',thClass:'w-40'},
                {name:'Cihaz İsmi',key:'Alias',thClass:'w-40'},
                {name:'Son Aktif Tarih',key:'LastDataTime',thClass:'w-20'},
                {name:'Aktif',key:'IsActive'},
            ],
            buttons:[
                { text:"Aktif Et",key:"active",icon:"CheckCircleIcon",variant:"success",action:this.changeActiveStatus,condition:(item) => !item.IsActive },
                { text:"Deaktif Et",key:"deactive",icon:"XCircleIcon",variant:"secondary",action:this.changeActiveStatus,condition:(item) => item.IsActive },
                { text:"İsimlendir",key:"rename",icon:"TypeIcon",variant:"info",action:this.rename },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            loading:false,
            app:{
                IdentifyCode:null,
                Alias:null
            }
        }
    },
    methods:{
        provider(data){
            return MobileDeviceOperationsApi.Table(data)
        },
        changeActiveStatus(item){
            this.$refs.table.rowLoading(true)
            MobileDeviceOperationsApi.ChangeActiveStatus(item.IdentifyCode).then(res=>{
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
                this.$result(res)
                this.$refs.table.rowLoading(false)
            }).catch(err =>{
                this.$result(null,err)
                this.$refs.table.rowLoading(false)
            })
        },
        rename(item){
            this.app.IdentifyCode = null
            this.app.Alias = null
            this.app.IdentifyCode = item.IdentifyCode
            this.app.Alias = item.Alias
            this.$showModal('rename')
        },
        setAlias(){
            this.loading = true
            MobileDeviceOperationsApi.UpdateAlias(this.app.IdentifyCode,this.app.Alias).then(res=>{
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('rename')
                }
                this.$result(res)
                this.loading = false
            }).catch(err => {
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem "${item.IdentifyCode}" IDli cihazı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    MobileDeviceOperationsApi.Delete(item.IdentifyCode).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        downloadTMSHR(){
            Additional.DownloadTab('https://tms.sertellojistik.com/api/api/download/tms-hr')
        }
    }
}
</script>